import React from "react";

import { FormControlLabel, Switch } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { useAppDispatch, useAppSelector } from "store";
import {
    selectShowUnclassifiedCategoryStores,
    toggleShowUnclassifiedCategoryStores
} from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";

const StyledSwitch = withStyles(theme => ({
    switchBase: {
        "&$checked": {
            // @ts-ignore
            color: theme.palette.tertiary.main,
        },
        "&$checked + $track": {
            // @ts-ignore
            backgroundColor: theme.palette.tertiary.main
        }
    },
    checked: {},
    track: {}
}))(Switch);

const UnclassifiedCategorySwitch: React.FC = () => {
    const dispatch = useAppDispatch();
    const showUnclassifiedCategoryStores = useAppSelector(selectShowUnclassifiedCategoryStores);

    const onChange = () => {
        dispatch(toggleShowUnclassifiedCategoryStores());
    };

    const unclassifiedCategroyStoresSwitch = (<StyledSwitch
        size="small"
        color="default"
        checked={showUnclassifiedCategoryStores}
        onChange={onChange}
    />);

    return (
        <FormControlLabel
            control={unclassifiedCategroyStoresSwitch}
            label="Show unclassified stores"
        />

    );
};

export default UnclassifiedCategorySwitch;
